<template>
    <Modal name="Assumptions">
        <form class="AssumptionsModal" @submit.prevent="close">
            <p class="AssumptionsModal__intro">Some assumptions have been made to determine how much insurance you might need.  You can alter the assumptions here specifically for your own circumstances.</p>

            <div class="AssumptionsModal__costs">
                <AssumptionInput
                    v-model.number="funeralCost"
                    :isMoney="true"
                    :validation="$v.funeralCost"
                    error="Funeral Cost. Error: Please enter a cost between 0 and 15000"
                >
                    <span>Funeral costs <br> (up to $15,000)</span>
                </AssumptionInput>

                <AssumptionInput
                    v-if="!funeralOnly"
                    v-model.number="yearsStdLiving"
                    :isMoney="false"
                    :validation="$v.yearsStdLiving"
                    error="Years of guaranteed standard of living. Error: Please enter a number between 1 and 5"
                    type="number"
                >
                    <span>Years of guaranteed standard of living <br> (1 – 5 Years)</span>
                </AssumptionInput>

                <AssumptionInput
                    v-if="!funeralOnly && childrenInDaycare"
                    v-model.number="childcareWeekly"
                    :isMoney="true"
                    :validation="$v.childcareWeekly"
                    error="Chidcare cost weekly. Error: Please enter a cost of no more than 500 per child"
                >
                    <span>Cost of childcare <br> (up to $500 per week per child)</span>
                </AssumptionInput>

                <AssumptionInput
                    v-if="!funeralOnly && childrenInSchool"
                    v-model.number="activeSchool"
                    :isMoney="true"
                    :validation="$v[activeSchoolHandle]"
                    error="Cost of schooling. Error: Please enter a cost of no more than 50000 per child"
                >
                    <span>Cost of schooling <br> (up to $50,000 per year per child)</span>
                </AssumptionInput>
            </div>

            <button class="btn AssumptionsModal__button" :aria-label="this.$v.$invalid && 'Please review form input errors before recalculating'">Recalculate</button>


            <InfoBox
                class="AssumptionsModal__infoBox"
                style="background-color: #f3f3f3"
            >
                <p>View the <a target="_blank" href="./static/assumptions.pdf">Purpose, Assumptions, Methodology and Disclaimer.</a></p>
            </InfoBox>

        </form>
    </Modal>
</template>

<script>
    import Modal from '@/components/Modal.vue';
    import InfoBox from '@/components/InfoBox.vue';
    import AssumptionInput from '@/components/AssumptionInput';
    import { mapState, mapActions } from 'vuex';
    import { required, requiredUnless, minValue, maxValue } from 'vuelidate/lib/validators'
    import { childrenInDaycare, childrenInSchool, capitalise } from '@/utilities/utilities';

    export default {
        components: { Modal, InfoBox, AssumptionInput },

        data: () => ({
            funeralCost: null,
            yearsStdLiving: null,
            childcareWeekly: null,
            schoolAnnualPrivate: null,
            schoolAnnualGovernment: null,

            childrenInDaycare: null,
            childrenInSchool: null
        }),

        computed: {
            funeralOnly() {
                return this.$store.state.calculator === 'express';
            },
            activeSchool: {
                get() {
                    return this[this.activeSchoolHandle];
                },
                set(newValue) {
                    this[this.activeSchoolHandle] = newValue;
                }
            },
            activeSchoolHandle() {
                const schoolType = this.$store.state.school;
                return schoolType ? `schoolAnnual${capitalise(this.$store.state.school)}` : 'schoolAnnualGovernment';
            }
        },

        created() {
            Object.keys(this.$data).forEach(assumption => {
                this[assumption] = Math.round(this.$store.state[assumption]);
            });

            this.childrenInDaycare = childrenInDaycare(this.$store.state.childrenAge);
            this.childrenInSchool = childrenInSchool(this.$store.state.childrenAge);

            if (!this.childrenInDaycare) this.childcareWeekly = null;

            if (!this.childrenInSchool) {
                this.schoolAnnualGovernment = null;
                this.schoolAnnualPrivate = null;
            }
        },

        methods: {
            ...mapActions(['update']),

            updateFields() {
                Object.keys(this.$data).forEach(assumption => {
                    const value = this.$data[assumption];
                    this.update({name: assumption, value })
                });
            },

            isMoney(assumption) {
                return assumption !== 'yearsStdLiving';
            },

            close() {
                if(!this.$v.$invalid) {
                    this.updateFields();
                    this.$modal.hide('Assumptions')
                }
            }
        },

        validations: {
            funeralCost: {
                required,
                maxValue: maxValue(15000)
            },
            yearsStdLiving: {
                required,
                minValue: minValue(1),
                maxValue: maxValue(5)
            },
            childcareWeekly: {
                required: requiredUnless((model) => model.funeralOnly || !model.childrenInDaycare),
                // maxValue(value) {
                //     return maxValue(500 * this.$store.state.childrenAge.length)(value)
                // }
            },
            schoolAnnualPrivate: {
                required: requiredUnless((model) => model.funeralOnly || !model.childrenInSchool),
                // maxValue(value) {
                //     return maxValue(50000 * this.$store.state.childrenAge.length)(value)
                // }
            },
            schoolAnnualGovernment: {
                required: requiredUnless((model) => model.funeralOnly || !model.childrenInSchool),
                // maxValue(value) {
                //     return maxValue(50000 * this.$store.state.childrenAge.length)(value)
                // }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .AssumptionsModal {

    }

    .AssumptionsModal__intro {
        font-size: 14px;

        @screen sm {
            font-size: 18px;
        }
    }

    .AssumptionsModal__infoBox {
        margin-top: 30px;
    }

    .AssumptionsModal__costs {
        margin: 40px auto;
        max-width: 450px;
    }

    .AssumptionsModal__button {
        margin-top: 20px;
    }
</style>